import { render } from "./PaymentScheduleTable.vue?vue&type=template&id=10d8b4d5&scoped=true"
import script from "./PaymentScheduleTable.vue?vue&type=script&lang=js"
export * from "./PaymentScheduleTable.vue?vue&type=script&lang=js"

import "./PaymentScheduleTable.vue?vue&type=style&index=0&id=10d8b4d5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d8b4d5"]])

export default __exports__